// BookIcon.tsx

import React from 'react'

const CopyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M15.24 2.62354H11.346C9.582 2.62354 8.184 2.62354 7.091 2.77154C5.965 2.92354 5.054 3.24354 4.336 3.96454C3.617 4.68554 3.298 5.60053 3.147 6.73054C3 7.82854 3 9.23153 3 11.0025V16.8405C3 18.3485 3.92 19.6405 5.227 20.1825C5.16 19.2725 5.16 17.9975 5.16 16.9355V11.9255C5.16 10.6445 5.16 9.53953 5.278 8.65553C5.405 7.70753 5.691 6.79954 6.425 6.06254C7.159 5.32554 8.064 5.03854 9.008 4.91054C9.888 4.79254 10.988 4.79254 12.265 4.79254H15.335C16.611 4.79254 17.709 4.79254 18.59 4.91054C18.3261 4.23683 17.8653 3.65827 17.2678 3.25032C16.6702 2.84236 15.9635 2.62394 15.24 2.62354Z"
        fill="#FCDCB4"
      />
      <path
        d="M6.59998 12.0203C6.59998 9.29431 6.59998 7.9313 7.44398 7.0843C8.28698 6.2373 9.64398 6.2373 12.36 6.2373H15.24C17.955 6.2373 19.313 6.2373 20.157 7.0843C21.001 7.9313 21 9.29431 21 12.0203V16.8403C21 19.5663 21 20.9293 20.157 21.7763C19.313 22.6233 17.955 22.6233 15.24 22.6233H12.36C9.64498 22.6233 8.28698 22.6233 7.44398 21.7763C6.59998 20.9293 6.59998 19.5663 6.59998 16.8403V12.0203Z"
        fill="#FCDCB4"
      />
    </svg>
  )
}

export default CopyIcon
